import React, { Component } from "react";
import { makeID, formDate } from "./helper";
import Question from "./question";
import Timer from "./timer";
import $ from "jquery";
import Vysledek from "./vysledek";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import InfoStranka from "./infostranka";
import emailjs from 'emailjs-com';

import "firebase/auth";
import "firebase/database";
require("firebase/functions");

class Questions extends Component {
  state = {
    actualQuestion: this.props.krok,
    finishedQuestion: this.props.krok,
    vybranaOdpoved: 0,
    textovaOdpoved: "",
    hlaseni: "",
    penalizace: this.props.penale,
    pouzitychNapoved: 0,
    maxKrok: 0,
    mailOdeslan: false,
    otazky: []
  };

  penalizaceZaPreskok = 1800;
  penalizaceZaSpatnouOdpoved = 300;

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    //this.componentDidMount = this.componentDidMount.bind(this);

    //console.log("Construstor loading", props);
    fetch("/slunce.json")
      .then(response => response.json())
      //.then(response => response.text())
      //.then(text => console.log(text))
      .then(data => {
        //console.log("ZZ", data);
        this.setState({ otazky: data });
        //console.log("JSON loaded");
      })
      .catch(error => console.log("Chyba nacitani json", error));
    //console.log("Constructor finished", this.state.otazky);
  }

  // handleChange = event => {
  //   console.log("Spoustim handle change", event);
  //   this.setState({ actualQuestion: event.target.value });
  // };

  componentDidMount() {
    // var a = JSON.stringify(this.state.otazky);
    // console.log("JSON:", a);
    //console.log("Questions  mounted", this.props);
    this.setState({ actualQuestion: this.props.krok });
  }

  componentDidUpdate(prevProps, prevstate) {
    //console.log("Aaa", this.state);
    if (this.state.actualQuestion > this.state.maxKrok) {
      //console.log("Zapisuji pokrok");
      this.logProgress();
      this.setState({ maxKrok: this.state.actualQuestion });
    }

    if (this.state.penalizace > prevstate.penalizace) {
      //console.log("Zapisuji penale");
      this.logProgress();
    }
  }

  handleSubmit = event => {
    try {
      //.log("Odeslano", event);
      if (this.state.vybranaOdpoved === 0) {
        event.preventDefault(event);
      } else {
        //console.log("Neprazdna odpoved");
        const aktOtazka = this.state.otazky[this.state.actualQuestion];
        //console.log("kr 1");
        let odpovedi = aktOtazka.spravnaOdpoved.split(",");
        //console.log("kr 2");
        let upravenaOdpoved = this.state.vybranaOdpoved
          .toUpperCase()
          //   .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");
        //console.log("kr 3");
        let ok = false;
        //console.log("kr 4");
        for (var i = 0; i < odpovedi.length; i++) {
          if (
            upravenaOdpoved ===
            odpovedi[i]
              .toUpperCase()
              //.normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
          ) {
            ok = true;
          }
        }
        //console.log("kr 5");

        //console.log("Mezikrok");
        if (ok) {
          this.collapseCollapsible();

          this.setState({ actualQuestion: this.state.actualQuestion + 1 });
          this.setState({ finishedQuestion: this.state.actualQuestion + 1 });
          this.setState({ vybranaOdpoved: 0 });
          this.setState({ textovaOdpoved: "" });
          this.setState({ hlaseni: "" });
          this.setState({ pouzitychNapoved: 0 });

          //console.log("Nove:", this.state.textovaOdpoved);

          //this.logProgress();
        } else {
          // Odeslana spatna odpoved
          this.setState({ hlaseni: "Chybná odpověď !" });
          this.setState({
            penalizace: this.state.penalizace + this.penalizaceZaSpatnouOdpoved
          });
        }

        //console.log("New actq", newActQ, event);
        event.preventDefault(event);
      }
    } catch (error) {
      //console.error(error);
    }
    event.preventDefault(event);
  };

  // makeID = user => {
  //   let vysledek = user.email.replace("@", "(at)").replace("/./g", "(tecka)");
  //   return vysledek;
  // };

  logProgress = () => {
    //console.log("Zapisuji progress: " + this.state.actualQuestion);
    var user = firebase.auth().currentUser;

    var now = new Date();
    var todayUTC = new Date(
      Date.UTC(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        now.getHours(),
        now.getMinutes(),
        now.getSeconds()
      )
    );
    var cas = todayUTC.toISOString();

    firebase
      .database()
      .ref("Hry/")
      .child(makeID(user))
      .update({
        krok: this.state.actualQuestion,
        penale: this.state.penalizace,
        posledniZmena: cas
      })
      .then(data => {
        //success callback
        //console.log("data ", data);
      })
      .catch(error => {
        //error callback
        //console.log("error ", error);
      });
  };

  handleSkip = event => {
    this.setState({ actualQuestion: this.state.actualQuestion + 1 });
    this.setState({ finishedQuestion: this.state.actualQuestion + 1 });
    this.setState({
      penalizace: this.state.penalizace + this.penalizaceZaPreskok
    });
    this.setState({ textovaOdpoved: "" });
    this.setState({ hlaseni: "" });
    this.setState({ pouzitychNapoved: 0 });
    this.collapseCollapsible();
    //this.logProgress();
    event.preventDefault(event);
  };

  handleChange = event => {
    //console.log("Zmena odpovedi", event.target.value);
    // const otazky = [...this.state.otazky];
    // otazky.vybranaOdpoved = event.target.value;

    //console.log("Handle change", typeof event.target.value, event.target.value);

    this.setState({ vybranaOdpoved: event.target.value });
    this.setState({ textovaOdpoved: event.target.value });
    this.setState({ hlaseni: "" });

    //console.log("Objekt otazky", otazky);
    //this.setState({ otazky });
  };

  collapseCollapsible() {
    $("#napoveda1").collapse("hide");
    $("#napoveda2").collapse("hide");
    $("#napoveda3").collapse("hide");
  }

  render() {
    //console.log("Actual question", this.state.actualQuestion);
    return (
      <React.Fragment>
        <div>{this.renderObsah()}</div>
      </React.Fragment>
    );
  }

  renderObsah = () => {
    //console.log(this.state.actualQuestion, this.state.otazky.length);
    if (this.state.otazky.length === 0) return;

    //this.getFinalTime();

    if (this.state.actualQuestion < this.state.otazky.length) {
      return (
        <React.Fragment>
          <Timer start={this.props.start} penalizace={this.state.penalizace} />
          {/* <h1>Otazka {this.state.actualQuestion}</h1> */}

          {this.state.otazky[this.state.actualQuestion].otazka === undefined ? (
            <InfoStranka
              zadani={this.state.otazky[this.state.actualQuestion]}
              onNext={this.handleNext}
              onPrev={this.handlePrev}
            />
          ) : (
            <Question
              zadani={this.state.otazky[this.state.actualQuestion]}
              selected={this.state.vybranaOdpoved}
              textovaOdpoved={this.state.textovaOdpoved}
              hlaseni={this.state.hlaseni}
              onSubmit={this.handleSubmit}
              onSkip={this.handleSkip}
              onChange={this.handleChange}
              onReveal={this.Reveal}
              pouzitychNapoved={this.state.pouzitychNapoved}
              onNext={this.handleNext}
              onPrev={this.handlePrev}
              finishedQuestion={
                this.state.finishedQuestion > this.state.actualQuestion
              }
              onKeyPress={this.handleKeyPress}
            />
          )}
        </React.Fragment>
      );
    } else {
      return <Vysledek cas={this.getFinalTime()} />;
    }
  };

  /// Kvuli odesilani na stisknuti enteru
  handleKeyPress = event => {
    //console.log("Key press", event);
    if (event.key === "Enter") {
      //console.log("Stisknut enter");
      this.handleSubmit(event);
    }
    //event.preventDefault(event);
  };

  handleNext = event => {
    this.setState({ actualQuestion: this.state.actualQuestion + 1 });
    this.setState({ hlaseni: "" });
    this.setState({ pouzitychNapoved: 0 });
    this.collapseCollapsible();
    event.preventDefault(event);
    //this.logProgress();
  };

  handlePrev = event => {
    if (this.state.actualQuestion > 0) {
      this.setState({ actualQuestion: this.state.actualQuestion - 1 });
      this.setState({ hlaseni: "" });
      this.setState({ pouzitychNapoved: 0 });
      this.collapseCollapsible();
    }
    event.preventDefault(event);
  };

  getFinalTime = () => {
    let elapsed = new Date() - this.props.start + this.state.penalizace * 1000;
    elapsed = Math.round(elapsed / 1000);

    var seconds = Math.round(elapsed % 60)
      .toString()
      .padStart(2, "0");
    var minutes = Math.floor(elapsed / 60);

    let cas = minutes + ":" + seconds;

    if (this.state.otazky.length !== 0) {
      this.writeFinalTime(cas, this.state.penalizace);
      this.mailFinal(cas);
    }

    return cas;
  };

  mailFinal = cas => {
    console.log("Volani mailFinal", cas);

    if (this.state.mailOdeslan === false) {

      var user = firebase.auth().currentUser;


      var email = "";
      firebase
      .database()
      .ref("Hry/" + user.uid)
      .once("value", snapshot => {

        console.log("Prectena data", snapshot.val());
        email = snapshot.val().email;

       
        var minutes = Math.floor(this.state.penalizace / 60);
  
        if (this.state.mailOdeslan === false)
        {
          //console.log("Volam mailfinal:",email);
        let templateId = 'template_ofk7llk';
        this.sendFeedback(templateId, 
          {
            jmeno_hry: "Free únikovka",
            //from_name: "unikovka.locksmith.escape@gmail.com", 
            //reply_to: "unikovka.locksmith.escape@gmail.com",
            to: email,
            cas: cas,
            start: formDate(new Date(this.props.start)),
            konec: formDate(new Date()),
            penale: minutes
          })
        }
      });

     

    
      
      // let info =  transporter.sendMail({
      //   from:'"Unikovka Locksmith escape" <unikovka.locksmith.escape@gmail.com>',
      //   to: user.email,
      //   subject: "Hra dokončena",
      //   html:
      //   "Gratulujeme, <br>Hru jste dokončili v čase: " +
      //   cas +
      //   " minut. <br><br>" +
      //   "start: " +
      //   formDate(new Date(this.props.start)) +
      //   "<br>konec: " +
      //   formDate(new Date()) +
      //   "<br>penále:" +
      //   minutes +
      //   " min<br>" +
      //   "Pro získání slevy 50% uveďte při rezervaci přihlašovací heslo z právě odehrané hry"
      // });


      // var addMessage = firebase.functions().httpsCallable("sendMail");
      // addMessage({
      //   text: cas,
      //   start: formDate(new Date(this.props.start)),
      //   konec: formDate(new Date()),
      //   penale: minutes
      // }).then(function(result) {
      //   // Read result of the Cloud Function.
      //   //var sanitizedMessage = result.data.text;
      //   //console.log("Vysledek volani" + result);
      // });
      //console.log("konec mailfinal");
      //this.setState({ mailOdeslan: true });
    }
  };

  sendFeedback(templateId, variables)
  {
    emailjs.send(
      'unikovka',templateId,
      variables,'user_5DrUlnJOxDihQiKteAwB3'
      ).then(
        this.setState({ mailOdeslan: true })
      );
  }

  writeFinalTime = (cas, penale) => {
    //console.log("Writing final time", cas, penale);
    let konec = Date.now();
    let dokonceno = true;
    var user = firebase.auth().currentUser;

    firebase
      .database()
      .ref("Hry/")
      .child(makeID(user))
      .update({
        konec,
        cas,
        penale,
        dokonceno
      })
      .then(data => {
        //success callback
        //console.log("data ", data);
      })
      .catch(error => {
        //error callback
        //console.log("error ", error);
      });
  };

  Reveal = event => {
    //console.log("Napoveda", event.target.id);
    if (event.target.id > this.state.pouzitychNapoved) {
      this.setState({ pouzitychNapoved: this.state.pouzitychNapoved + 1 });
      this.setState({
        penalizace: this.state.penalizace + this.penalizaceZaSpatnouOdpoved
      });
    }
    event.preventDefault(event);
  };
}

export default Questions;
